/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * @class MBP Utilities API
 */

import { getEnv, getJWT, setJWT, testJWT } from './mbpUtil';

const mbpUtil = {
    getEnv, getJWT, setJWT, testJWT,
};

export default mbpUtil;
